// extracted by mini-css-extract-plugin
module.exports = {"changed":"VisaworkflowSettingsForm_changed__1CA1c","FormButton":"VisaworkflowSettingsForm_FormButton__3VSs-"};